import type { ReactNode } from 'react';

import { ROUTES } from '@/app/router/routes';
import {
  CalendarIcon,
  BriefcaseIcon,
  BuildingContactsIcon,
  ClipboardCheckIcon,
  FolderKanbanIcon,
  InvoiceIcon,
  LayoutGridIcon,
  MailIcon,
  TargetIcon,
  TimesheetIcon,
  UsersIcon,
} from '@/components/icons';

/**
 * Un module de la navigation.
 *
 * `to` reste `string | null` alors que tous les modules ont aujourd'hui leur
 * écran : le type dit ce que la structure admet, pas ce qu'elle contient. Sans
 * lui, TypeScript déduirait qu'aucun module ne peut être inactif et
 * signalerait comme mort le code qui les affiche — code qu'il faudrait
 * réécrire au premier module suivant.
 */
export interface NavItem {
  label: string;
  to: string | null;
  icon: (props: { className?: string }) => ReactNode;
}

/** Les modules à venir restent visibles sans lien vers des pages inexistantes. */
export const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Tableau de bord', to: ROUTES.dashboard, icon: LayoutGridIcon },
  { label: 'Candidats', to: ROUTES.candidates, icon: UsersIcon },
  { label: 'Société · Contacts', to: ROUTES.companies, icon: BuildingContactsIcon },
  { label: 'Besoins', to: ROUTES.requirements, icon: BriefcaseIcon },
  { label: 'Actions', to: ROUTES.actions, icon: ClipboardCheckIcon },
  { label: 'Entretiens', to: ROUTES.interviews, icon: CalendarIcon },
  { label: 'Tâches', to: ROUTES.tasks, icon: ClipboardCheckIcon },
  { label: 'Ventes · ADV', to: ROUTES.adv, icon: InvoiceIcon },
  { label: 'Achats', to: '/achats', icon: ClipboardCheckIcon },
  { label: 'Prospection', to: ROUTES.prospection, icon: TargetIcon },
  { label: 'CRA', to: ROUTES.timesheets, icon: TimesheetIcon },
  { label: 'Projets', to: ROUTES.projects, icon: FolderKanbanIcon },
  { label: 'Messagerie', to: ROUTES.messaging, icon: MailIcon },
];

export const isModuleActive = (pathname: string, to: string | null) =>
  to !== null &&
  (pathname === to ||
    pathname.startsWith(to + '/') ||
    (to === ROUTES.companies && pathname.startsWith('/contacts/')));
